import type { ThemeTypes } from "@/types/theme/themeType";

const BLUE_THEME: ThemeTypes = {
  name: "BLUE_THEME",
  dark: false,
  variables: {
    "border-color": "#e5eaef",
    "border-opacity": 1
  },
  colors: {
    primary: "#5D87FF",
    secondary: "#49BEFF",
    info: "#539BFF",
    success: "#13DEB9",
    accent: "#FFAB91",
    warning: "#FFAE1F",
    error: "#FA896B",
    red: "#F04447",
    purple: "#B060FF",
    lightprimary: "#ECF2FF",
    lightsecondary: "#E8F7FF",
    lightsuccess: "#E6FFFA",
    lighterror: "#FDEDE8",
    lightinfo: "#EBF3FE",
    lightwarning: "#FEF5E5",
    textPrimary: "#2A3547",
    textSecondary: "#2A3547",
    borderColor: "#e5eaef",
    inputBorder: "#DFE5EF",
    containerBg: "#ffffff",
    background: "#ffffff",
    hoverColor: "#f6f9fc",
    surface: "#fff",
    "on-surface-variant": "#fff",
    grey100: "#F2F6FA",
    grey200: "#EAEFF4"
  }
};

export { BLUE_THEME };
